import styles from './Loader.css';
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';

export default class Loader extends Component {
  static propTypes = {
    text: PropTypes.string,
    noText: PropTypes.bool,
    theme: PropTypes.string
  };

  render () {
    const text = this.props.text || '';
    let theme_light = this.props.theme;

    return (
      <div className={styles.container}>
        <div className={classnames(styles.spinner, {[styles._light]: theme_light === 'light'})}>
          <div className={styles.bounce1}></div>
          <div className={styles.bounce2}></div>
          <div className={styles.bounce3}></div>
        </div>
        {
          !this.props.noText &&
            <span className={classnames(styles.loadText, {[styles._light]: theme_light === 'light'})}>
              {text}
            </span>
        }
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/views/BaseElements/Loader/Loader.js
 **/